import { Validations } from '@/utils'
import { VTextField } from 'vuetify/lib'
import InputLabel from './InputLabel'

const PRECISION = 2
const LOCALE = 'pt-BR'

/**
 * InputMoney Component
 * @class InputMoney
 * @extends {InputBasico}
 */

export const InputMoney = VTextField.extend({
	name: 'InputMoney',
	extends: VTextField,
	props: {
		prefix: { default: 'R$' },
		outlined: { default: true },
		dense: { default: true },
		validateOnBlur: { default: true },
		label: { default: '', type: String },
		hint: { default: '', type: String },
		required: { default: false, type: Boolean },
		instructions: { default: '', type: String },
		persistentPlaceholder: { default: true },
		rules: { default: () => [], type: Array },
		noRequiredText: { type: Boolean, default: false }
	},
	data: () => ({
		lazyValue: ''
	}),

	computed: {
		internalValue: {
			get() {
				const value = this.value != null && this.value !== '' ? humanFormat(this.value) : this.lazyValue
				return value
			},

			set(value: string) {
				this.lazyValue = value != null && value !== '' ? humanFormat(value) : ''
				this.$emit('input', machineFormat(value))
			}
		}
	},
	methods: {
		handleKeypressPreventNonDigit(event: KeyboardEvent) {
			let keyCode = event.keyCode ? event.keyCode : event.which

			if (keyCode < 48 || keyCode > 57) {
				event.preventDefault()
			}
		}
	},

	render() {
		return (
			<div class="d-flex flex-column app--input-base_wrapper">
				{!this.label || this.label == undefined ? (
					<span />
				) : (
					<InputLabel
						label={this.label}
						required={this.required}
						instructions={this.instructions}
						hint={this.hint}
						noRequiredText={this.noRequiredText}
					/>
				)}
				<VTextField
					prefix={this.$props.prefix}
					outlined={this.$props.outlined}
					dense={this.$props.dense}
					validateOnBlur={this.$props.validateOnBlur}
					label={''}
					disabled={this.$props.disabled}
					//onInput={(value: string) => this.value = value}
					rules={[...this.$props.rules, this.$props.required ? Validations.isRequired : () => true]}
					hint={this.$props.hint}
					required={''}
					instructions={this.$props.instructions}
					persistentPlaceholder={this.$props.persistentPlaceholder}
					onKeypress={this.handleKeypressPreventNonDigit}
					v-model={this.internalValue}
					class="my-2"
				/>
			</div>
		)
	},

	watch: {
		value(val) {
			this.lazyValue = val
		}
	}
})

export default InputMoney

function isInteger(value: any) {
	let result = false
	if (Number.isInteger(parseInt(value))) {
		result = true
	}
	return result
}

function humanFormat(number: any) {
	if (isNaN(number)) return ''

	return Number(number).toLocaleString(LOCALE, {
		maximumFractionDigits: PRECISION,
		minimumFractionDigits: PRECISION
	})
}

function cleanNumber(value: any) {
	let result = ''
	if (value) {
		let flag = false
		let arrayValue = value.toString().split('')
		for (var i = 0; i < arrayValue.length; i++) {
			if (isInteger(arrayValue[i])) {
				if (!flag) {
					if (arrayValue[i] !== '0') {
						result = result + arrayValue[i]
						flag = true
					}
				} else {
					result = result + arrayValue[i]
				}
			}
		}
	}
	return result
}

export function machineFormat(number: any) {
	if (number) {
		number = cleanNumber(number)
		number = number.padStart(PRECISION + 1, '0')
		number = number.substring(0, number.length - PRECISION) + '.' + number.substring(number.length - PRECISION, number.length)

		if (isNaN(number)) return parseFloat('')
	}

	const parsed = parseFloat(number)

	if (isNaN(parsed)) return parseFloat('')

	return parsed
}

// export default InputMoney
